import { fetchJSON } from './getFetchReusable';
import { API_URL } from '../constantes/constantes';

/**
 * Obtiene los datos para el carrusel para unotv desde un endpoint específico.
 *
 * @param {Object} params
 * @param {string} params.endpoint - URL completa del JSON a consumir.
 * @returns {Promise<{ data: any, statusCode: number }>}
 */
export async function getCarrouselSponsoredUno({ endpoint }) {
  return await fetchJSON(`${API_URL}${endpoint}.json`);
}
